/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const Domain = core.serialization.enum_([
    "file",
    "space",
    "workbook",
    "flag",
    "job",
    "document",
    "sheet",
    "program",
    "secret",
    "cron",
    "environment",
    "data-clip",
    "canvas",
    "canvas-area",
    "thread",
]);
